import customEvent from './custom-event';
export default function elementInteraction(elementInteractionHeader) {
  customEvent('ELEMENT_INTERACTION_EVENT', null, {
    elementInteractionHeader: elementInteractionHeader
  });
}